import { Box, Typography } from "@mui/material";
import { useState } from "react";

import "./PandingRequest.scss";
import PublishIndia from "../../components/PublishIndia/PublishIndia";
import PublishStatelevel from "../../components/PublishState/PublishStatelevel";
import PublishCategorymain from "../../components/Publishcategory/PublishCategorymain";
import PublishIndiaPdf from "../../components/PublishIndiaPDF/PublishIndiaPdf";
import PublishStatePDF from "../../components/PublishStatePDF/PublishStateData";
import PublishIndiaImage from "../../components/PublishIndiaImage/PublishIndiaImage";
import PublishStateImage from "../../components/PublishStateImage/PublishStateImage";

const Home = () => {
  const [toggle, setToggle] = useState<string | null>("india");
  const [indiaCount, setIndiaCount] = useState<number>(0);
  const [indiaPDFCount, setIndiaPDFCount] = useState<number>(0);
  const [stateCount, setStateCount] = useState<number>(0);
  const [statePDFCount, setStatePDFCount] = useState<number>(0);
  const [categoryCount, setCategoryCount] = useState<number>(0);

  const [indiaImageCount, setIndiaImageCount] = useState<number>(0);
  const [stateImageCount, setStateImageCount] = useState<number>(0);

  return (
    <Box className="container-wraper">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          paddingBottom: "5px",
        }}
      >
        <Typography className="bold-header-text">
          <b>Pending Request</b>{" "}
        </Typography>
      </Box>
      <Box className="toggle-wrapper">
        <Box
          onClick={() => {
            setToggle("india");
          }}
          className={toggle === "india" ? "toggle-btn" : "toggle-btn2"}
        >
          {" "}
          <Typography
            className={toggle === "india" ? "toggle-txt" : "toggle-txt2"}
          >
            India Level
          </Typography>
          <Box className="count-txt">
            {indiaCount + indiaPDFCount + indiaImageCount}
          </Box>
        </Box>
        <Box
          onClick={() => {
            setToggle("state");
          }}
          className={toggle === "state" ? "toggle-btn" : "toggle-btn2"}
        >
          {" "}
          <Typography
            className={toggle === "state" ? "toggle-txt" : "toggle-txt2"}
          >
            State Level
          </Typography>
          <Box className="count-txt">
            {stateCount + statePDFCount + stateImageCount}
          </Box>
        </Box>
        <Box
          onClick={() => {
            setToggle("category");
          }}
          className={toggle === "category" ? "toggle-btn" : "toggle-btn2"}
        >
          <Typography
            className={toggle === "category" ? "toggle-txt" : "toggle-txt2"}
          >
            Category
          </Typography>
          <Box className="count-txt">{categoryCount}</Box>
        </Box>
        {/* 2 extra */}
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Box sx={{ marginBottom: "1px !important" }} />
        {/*Data Table*/}

        <PublishIndia
          setIndiaPDFCount={setIndiaPDFCount}
          setIndiaCount={setIndiaCount}
          visible={toggle === "india"}
        />

        <PublishStatelevel
          setStateCount={setStateCount}
          visible={toggle === "state"}
          setStatePDFCount={setStatePDFCount}
        />

        <PublishCategorymain
          setCategoryCount={setCategoryCount}
          visible={toggle === "category"}
        />

        <PublishIndiaPdf
          setIndiaPDFCount={setIndiaPDFCount}
          visible={toggle === "India PDF"}
        />

        <PublishIndiaImage
          setIndiaImageCount={setIndiaImageCount}
          visible={toggle === "india"}
        />

        <PublishStatePDF
          setStatePDFCount={setStatePDFCount}
          visible={toggle === "State PDF"}
        />
        <PublishStateImage
          setStateImageCount={setStateImageCount}
          visible={toggle === "state"}
        />
      </Box>
    </Box>
  );
};

export default Home;
